import React from "react";
import { useFormikContext } from "formik";
import { getFieldPath, getToggleProps, integerTransformer } from "utils/form";
import get from "lodash/get";
import Toggle from "react-toggle";
import { FORM_KEY } from "utils/constants/form";
import ConnectedField from "components/ConnectedField";
import SectionBezel from "components/SectionBezel";
import DesktopDatePicker from "components/DesktopDatePicker";
import MobileDatePicker from "components/MobileDatePicker";
import { useViewport } from "utils/context";
import { INPUT_TYPE } from "utils/constants/ui";
import { getIconForUID } from "components/FormerEditor/utils";

const RestrictionFields = ({ name }) => {
  const {
    values,
    touched,
    setFieldValue,
    setFieldTouched
  } = useFormikContext();
  const canEdit = !Boolean(values.id);
  const LockIcon = getIconForUID("lock");
  const locked = !canEdit && <LockIcon size={18} />;

  const { isSmall } = useViewport();
  const redeemByPath = getFieldPath(name, `redeem_by`);
  const redeemByTouched = get(touched, redeemByPath);
  const redeemByActivePath = getFieldPath(name, `${FORM_KEY}.redeem_by`);
  const redeemByActive = get(values, redeemByActivePath);
  const idPath = getFieldPath(name, "id");
  const id = get(values, idPath);
  const editMode = Boolean(id);

  const maxRedemptionsPath = getFieldPath(name, `max_redemptions`);
  const maxRedemptionsActivePath = getFieldPath(
    name,
    `${FORM_KEY}.max_redemptions`
  );
  const maxRedemptionsActive = get(values, maxRedemptionsActivePath);

  const onChange = (date) => {
    setFieldValue(redeemByPath, date);
    if (!redeemByTouched) {
      setTimeout(() => setFieldTouched(redeemByPath, true), 0);
    }
  };
  /**
   * Note Stripe API only permits edit of name and metadata
   * So we disable update of these fields when in edit mode
   * https://stripe.com/docs/api/coupons/update?lang=node
   */
  const preventInteraction = Boolean(editMode || !redeemByActive);
  const pickerProps = {
    name: redeemByPath,
    readOnly: preventInteraction,
    disabled: preventInteraction,
    onChange
  };

  return (
    <SectionBezel header="Restrictions" action={locked}>
      <div className="w-100">
        <div className="flex flex-row justify-between items-center pb2">
          <label className="field__label fw5 db">Expiration</label>
          <Toggle
            {...getToggleProps({
              active: redeemByActive,
              disabled: editMode,
              setFieldValue: (_, active) => {
                setFieldValue(redeemByActivePath, active);
                setFieldTouched(redeemByActivePath, true);
              }
            })}
          />
        </div>
        {isSmall ? (
          <MobileDatePicker {...pickerProps} />
        ) : (
          <DesktopDatePicker {...pickerProps} />
        )}
      </div>
      <div className="w-100 pt3">
        <div className="flex flex-row justify-between items-center pb3">
          <label className="field__label fw5 db">Max redemptions</label>
          <Toggle
            {...getToggleProps({
              editMode,
              disabled: editMode,
              active: maxRedemptionsActive,
              setFieldValue: (_, active) => {
                setFieldValue(maxRedemptionsActivePath, active);
                setFieldTouched(maxRedemptionsActivePath, true);
              }
            })}
          />
        </div>
        <ConnectedField
          disabled={!maxRedemptionsActive || editMode}
          name={maxRedemptionsPath}
          inputMode={INPUT_TYPE.NUMERIC}
          transformer={integerTransformer}
        />
      </div>
    </SectionBezel>
  );
};

export default RestrictionFields;
